import PageBannerText from './PageBannerText'
export default PageBannerText
